<template lang="pug">
  ValidationProvider(:rules="rulesFormatted" v-slot="{ errors }")
    v-text-field(
      v-model="valuefield"
      :disabled="disabled"
      :error="errors.length > 0"
      :hint="hint"
      :outlined="outlined"
      :dense="dense"
      :solo="solo"
      :flat="flat"
      :type="type"
      @input="inputFill(errors)")
      template(v-slot:label)
        v-icon.pr-1(v-if="required" color="red accent-2" size="12") mdi-asterisk
        | {{ label }}
    span.red--text.text--accent-2(v-if="errors.length > 0")
      v-icon(color="red accent-2") mdi-alert
      |  {{ errors[0] }}
</template>

<script>
  export default {
    name: "BaseFloatField",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: String
        ,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      required: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      min: {
        type: String,
        default: ''
      },
      max: {
        type: String,
        default: ''
      },
      decimals: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'text'
      },
    },
    data:() => ({
      valuefield: null,
    }),
    computed: {
      outlined(){
        return this.$attrs.outlined != undefined;
      },
      dense(){
        return this.$attrs.dense != undefined;
      },
      solo(){
        return this.$attrs.solo != undefined;
      },
      flat(){
        return this.$attrs.flat != undefined;
      },
      hint(){
        return this.$t("validations.float.hint");
      },
      rulesFormatted(){
        let rules = {};
        if(this.required){
          rules.required = true;
        }
        if(this.min != ''){
          rules.min_float = {min: this.min}
        }
        if(this.max != ''){
          rules.max_float = {max: this.max}
        }
        if(this.decimals != ''){
          rules.decimals_float = {decimals: this.decimals}
        }
        return rules == {} ? '' : rules;
      }
    },
    watch: {
      value: function(val){
        this.valuefield = val;
      }
    },
    created(){
      this.valuefield = this.value;
    },
    methods:{
      inputFill(){
        this.$emit('input', this.valuefield);
      },
    },
  }
</script>

<style lang="sass">
</style>